import * as React from "react";
import { Typography, Box, Grid, CircularProgress } from "@mui/material";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { MainInput } from "../../app/components/Styles";
import { sendMessage } from "../../app/store/actions/commonActions";
import { MarketingPage, MarketingButton, MarketingFormCard } from "../../app/components/marketing";
import {
  marketingColors,
  marketingFonts,
  sectionLabelSx,
  sectionTitleSx,
} from "../../app/components/tickitMarketingTheme";

export const Contact = ({ sendMessage, isLoading, user }) => {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    sendMessage(
      {
        name: data.get("name") || "Anonymous",
        content: data.get("content"),
        email: data.get("email"),
      },
      navigate
    );
  };

  if (isLoading) {
    return (
      <MarketingPage>
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress sx={{ color: marketingColors.p700 }} />
        </Box>
      </MarketingPage>
    );
  }

  return (
    <MarketingPage maxWidth="md">
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography sx={sectionLabelSx}>Get in touch</Typography>
        <Typography variant="h2" sx={{ ...sectionTitleSx, fontSize: { xs: "1.75rem", md: "2.25rem" } }}>
          Contact us
        </Typography>
        <Typography sx={{ fontFamily: marketingFonts.body, color: marketingColors.gray500, mt: 1 }}>
          Questions about events, partnerships, or platform access — we&apos;ll get back to you.
        </Typography>
      </Box>

      <MarketingFormCard
        title="Send a message"
        subtitle="Fill in the form below and our team will respond as soon as possible."
      >
        <Box component="form" onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <MainInput margin="normal" fullWidth id="name" label="Name" name="name" />
            </Grid>
            <Grid item xs={12} sm={6}>
              <MainInput
                margin="normal"
                required
                fullWidth
                type="email"
                id="email"
                label="Email"
                name="email"
                defaultValue={user?.email || ""}
              />
            </Grid>
            <Grid item xs={12}>
              <MainInput
                margin="normal"
                required
                multiline
                fullWidth
                minRows={6}
                name="content"
                label="Message"
                id="content"
              />
            </Grid>
          </Grid>
          <MarketingButton type="submit" sx={{ mt: 3, minWidth: 160 }}>
            Send message
          </MarketingButton>
        </Box>
      </MarketingFormCard>
    </MarketingPage>
  );
};

const mapStateToProps = (state) => ({
  user: state?.auth?.user,
  isLoading: state?.wait?.isLoading,
});

export default connect(mapStateToProps, { sendMessage })(Contact);
